import React from 'react';

const VIMEO_ID = '1165405797';
const VIMEO_SRC = `https://player.vimeo.com/video/${VIMEO_ID}?title=0&byline=0&portrait=0&badge=0&autopause=0`;

const ResourcesFeatureVideoSection = () => (
    <section className="lp-res-feature">
        <div className="lp-container">
            <div className="lp-res-feature-head">
                <div className="lp-badge" data-lp-reveal><span />Watch</div>
                <h2 className="lp-h2" data-lp-reveal data-lp-delay="60">See Diligentsia in action.</h2>
                <p className="lp-sub" data-lp-reveal data-lp-delay="120">The whole platform in one short film — from first upload to an investor-ready diligence pack.</p>
            </div>

            <div className="lp-res-feature-player" data-lp-reveal data-lp-delay="180">
                <iframe
                    title="Diligentsia Ad"
                    src={VIMEO_SRC}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </div>
        </div>
    </section>
);

export default ResourcesFeatureVideoSection;
